// src/router/title.plugin.ts
export const titlePlugin = (router: any) => {
  // Runs after a route completes
  router.addEventListener("route-changed", (e: any) => {
    const route = e?.detail?.route;
    const title = route?.title;
    if (title) document.title = title;
  });
};
